$(function ()
{
	if (typeof FroalaEditor == "undefined") {
		return;
	}

	FroalaEditor.RegisterCommand('templates', {
		icon: 'magic-light',
		title: 'Templates',
		type: 'dropdown',
		focus: false,
		undo: true,
		refreshAfterCallback: false,

		html: function ()
		{
			var options = this.opts.templates;

			if (typeof (options) == 'undefined' || options.length == 0)
				return '';

			let html = '<ul class="fr-dropdown-list" role="presentation">';
			for (var val in options) {
				if (options.hasOwnProperty(val)) {
					if (typeof (options[val]) == "string") {
						html = html.concat('<li role="presentation" class="group">' + options[val] + '</li>');
					} else {
						html = html.concat('<li role="presentation"><a class="fr-command fr-title ct-extended" tabIndex="-1" role="option" data-cmd="templates" data-param1="' + val + '">');
						html = html.concat('<div class="title">' + options[val].title + '</div>');
						html = html.concat('<div class="description">' + options[val].description + '</div>');
						html = html.concat('</a>');
						html = html.concat('</li>');
					}
				}
			}

			html = html.concat('</ul>');
			return html;
		},

		callback: function (cmd, val)
		{
			this.html.insert(this.opts.templates[val].html, false);
			this.events.trigger('template.inserted', [], true);
			this.undo.saveStep();
		},
		// Callback on refresh.
		refresh: function ($btn)
		{
		},
		// Callback on dropdown show.
		refreshOnShow: function ($btn, $dropdown)
		{
		}
	});

});
